import { getNationality } from "../../../services/TabelasAuxiliares/getNationality";
import { getPartners } from "../../../services/TabelasAuxiliares/getPartner";
import { getProvince } from "../../../services/TabelasAuxiliares/getProvince";
import { getCounty } from "../../../services/TabelasAuxiliares/getCounty";

export const auxiliaresLookUps = [
  {
    name: "Províncias",
    id: 1,
    entityName: "Province",
    getFunction: getProvince,
    isStructural: true,
  },
  {
    name: "Municípios",
    id: 2,
    entityName: "County",
    getFunction: getCounty,
    isStructural: true,
    hasParent: true,
    hasProvince: true,
    getParent: getProvince,
    ParentName: "Províncias",
  },
  {
    name: "Nacionalidade",
    id: 3,
    entityName: "Nationality",
    getFunction: getNationality,
    isStructural: true,
  },
  {
    name: "Parceiros",
    id: 4,
    entityName: "Partner",
    getFunction: getPartners,
    isStructural: true,
  },
];
